import { UntitledUIThemeProvider } from '@trm/ui-kit-admin/v7/providers';
import { ReactNode } from 'react';

import { ThemeSynchronizer } from './ThemeSynchronizer';
import ThemeCustomization from './index';

interface ThemeProviderProps {
  children: ReactNode;
  untitledStorageKey?: string;
}

/**
 * Unified theme provider that wraps both MUI and UntitledUI theme systems.
 * Handles synchronization between the two systems automatically.
 *
 * MUI theme (via ThemeCustomization) is the source of truth.
 * UntitledUI CSS theme is kept in sync via ThemeSynchronizer.
 *
 * Note: Both systems use separate localStorage keys:
 * - MUI: localStorage['topstep-dashboard-config']
 * - UntitledUI: localStorage['ui-theme']
 * ThemeSynchronizer ensures they stay aligned.
 */
export const ThemeProvider = ({ children, untitledStorageKey }: ThemeProviderProps) => {
  return (
    <ThemeCustomization>
      <UntitledUIThemeProvider storageKey={untitledStorageKey}>
        <ThemeSynchronizer>{children}</ThemeSynchronizer>
      </UntitledUIThemeProvider>
    </ThemeCustomization>
  );
};
